import React from 'react';
import { useTranslation } from 'react-i18next';
import { useApplyBatchValues } from '../utils/previous-values-manager';
import BatchSelectionModal from './BatchSelectionModal';

interface BatchHistoryModalProps {
  show: boolean;
  onHide: () => void;
  currentValues: any;
  setValues: (values: any) => void;
  setInitialValues?: (values: any) => void;
}

const BatchHistoryModal: React.FC<BatchHistoryModalProps> = (props) => {
  const { t } = useTranslation();
  const applyBatchValues = useApplyBatchValues();

  return (
    <BatchSelectionModal
      {...props}
      title={t('Select Previous Batch')}
      submitButtonText={t('Apply Selected Batch')}
      submitButtonStyle="primary"
      onApplyBatch={applyBatchValues}
    />
  );
};

export default BatchHistoryModal;
